import * as React from "react";
import { EventCardSectionItem } from "../../EventCardSectionItem";
export const renderTeamsScore = (score1, score2) => 
//to-do: scoreboards
React.createElement(React.Fragment, null,
    React.createElement(EventCardSectionItem, { content: score1, className: "rj-ev-list__ev-card__score rj-ev-list__ev-card__score-home" }),
    React.createElement(EventCardSectionItem, { content: score2, className: "rj-ev-list__ev-card__score rj-ev-list__ev-card__score-away" }));
//# sourceMappingURL=renderTeamsScore.js.map